import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIRequestStatus } from 'common-ts/dist/models/APIRequestStatus';
import axios from 'axios';
import { fetchUnitItemsList } from "./UnitItemListPostRedux";

export interface UnitItemAddPostState {
  unitItemAddDraft: {
    unitItemId: string,
    amountToAdd: number,
  },

  dialogOpen: boolean,

  dialogInProgressAddOpen: boolean
  dialogInProgressFinishOpen: boolean

  status: APIRequestStatus,
  error: string | null,
}

const initialState: UnitItemAddPostState = {
    unitItemAddDraft: {
        unitItemId: '',
        amountToAdd: 0,
    },

    dialogOpen: false,

    dialogInProgressAddOpen: false,
    dialogInProgressFinishOpen: false,

    status: APIRequestStatus.Idle,
    error: ''
}

const slice = createSlice({
    name: 'unitItemStockAdd',
    initialState,
    reducers: {
        updateVal(state, action) {
          state.unitItemAddDraft = action.payload;
          console.log(`State values: ${JSON.stringify(state.unitItemAddDraft)}`);
        },
        updateDialogOpen(state, action) {
          state.dialogOpen = action.payload;
        },
        updateDialogInProgressAddOpen(state, action) {
          state.dialogInProgressAddOpen = action.payload;
        },
        updateDialogInProgressFinishOpen(state, action) {
          state.dialogInProgressFinishOpen = action.payload;
        }
    },
    extraReducers(builder) {
        builder
          .addCase(postUnitItemStockAdd.pending, (state, action) => {
            state.status = APIRequestStatus.RequestInProgress;
          })
          .addCase(postUnitItemStockAdd.fulfilled, (state, action) => {
            // We only close the dialog if the post is successful
            if (action.payload.success) {
              state.dialogOpen = false;
            }

            state.status = APIRequestStatus.Success;
            console.log("Post success.");
          })
          .addCase(postUnitItemStockAdd.rejected, (state, action) => {
            state.status = APIRequestStatus.Failure;
            console.log("Post failed.");
          })
          .addCase(postUnitItemStockAddPayload.pending, (state, action) => {
            state.status = APIRequestStatus.RequestInProgress;
          })
          .addCase(postUnitItemStockAddPayload.fulfilled, (state, action) => {
            // We only close the dialog if the post is successful
            if (action.payload.success) {
              state.dialogOpen = false;
              state.dialogInProgressAddOpen = false;
              state.dialogInProgressFinishOpen = false;
            }

            state.status = APIRequestStatus.Success;
            console.log("Post success.");
          })
          .addCase(postUnitItemStockAddPayload.rejected, (state, action) => {
            state.status = APIRequestStatus.Failure;
            console.log("Post failed.");
          })
          .addCase(postUnitItemWorkStockFinish.pending, (state, action) => {
            state.status = APIRequestStatus.RequestInProgress;
          })
          .addCase(postUnitItemWorkStockFinish.fulfilled, (state, action) => {
            // We only close the dialog if the post is successful
            if (action.payload.success) {
              state.dialogOpen = false;
              state.dialogInProgressAddOpen = false;
              state.dialogInProgressFinishOpen = false;
            }

            state.status = APIRequestStatus.Success;
            console.log("Post success.");
          })
          .addCase(postUnitItemWorkStockFinish.rejected, (state, action) => {
            state.status = APIRequestStatus.Failure;
            console.log("Post failed.");
          })
      }
})

export const postUnitItemStockAdd = createAsyncThunk('unitItemStockAdd/postUnitItemStockAdd', async (arg, thunkAPI) => {
    const state: any = thunkAPI.getState();

    const response = await axios({
      method: 'post',
      url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/unititem/add',
      data: state.unitItemStockAdd.unitItemAddDraft,
    });

    // Backend COGS guard (unitItemStockAdd/TakePost): stock is NOT changed when the SKU's cost is
    // still unresolved (product inserted moments ago) — otherwise counters would move with no GL entry.
    if (response.data?.rejected === "COGS_BELUM_RESOLVE") {
      window.alert(response.data?.message
      // The backend explains why (midstock unused / product cost 0) once deployed.
      ? "DITOLAK: " + response.data.message + " (Stok TIDAK diubah.)"
      : "DITOLAK: cogs " + (response.data?.unitItemId ?? "SKU ini") +
        " belum ter-resolve (produk baru?). Stok TIDAK diubah — isi cogs produk dulu, lalu coba lagi.");
    }

    thunkAPI.dispatch(fetchUnitItemsList());

    return response.data
})

export const postUnitItemStockAddPayload = createAsyncThunk('unitItemStockAdd/postUnitItemStockAddPayload', async (arg: any, thunkAPI) => {
    const state: any = thunkAPI.getState();

    const response = await axios({
      method: 'post',
      url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/unititem/add',
      data: arg,
    });

    // Backend COGS guard (unitItemStockAdd/TakePost): stock is NOT changed when the SKU's cost is
    // still unresolved (product inserted moments ago) — otherwise counters would move with no GL entry.
    if (response.data?.rejected === "COGS_BELUM_RESOLVE") {
      window.alert(response.data?.message
      // The backend explains why (midstock unused / product cost 0) once deployed.
      ? "DITOLAK: " + response.data.message + " (Stok TIDAK diubah.)"
      : "DITOLAK: cogs " + (response.data?.unitItemId ?? "SKU ini") +
        " belum ter-resolve (produk baru?). Stok TIDAK diubah — isi cogs produk dulu, lalu coba lagi.");
    }

    thunkAPI.dispatch(fetchUnitItemsList());

    return response.data
})

export const postUnitItemWorkStockFinish = createAsyncThunk('unitItemStockAdd/postUnitItemWorkStockFinish', async (arg: any, thunkAPI) => {
    const state: any = thunkAPI.getState();

    const response = await axios({
      method: 'post',
      url: 'https://8mav2hp6ki.execute-api.ap-southeast-1.amazonaws.com/OrderAPIProduction/work-stock-finish',
      data: {
        description: 'Penyelesaian stok ' + arg.unitItemId + ' sebanyak ' + arg.amountToAdd,
        resultDict: {
          ['ui-' + arg.unitItemId]: arg.amountToAdd,
        },
        processesData: [
          {
            processName: 'FINISH',
            processPoints: arg.pointsAwardedPerItem * arg.amountToAdd,
            timeSpent: arg.timeSpentPerItem * arg.amountToAdd,
            maxPeople: 1
          }
        ],
        processesExecutors: [
          [arg.executorId]
        ]
      },
    });

    thunkAPI.dispatch(fetchUnitItemsList());

    return response.data
})

export const { updateVal, updateDialogOpen, updateDialogInProgressAddOpen, updateDialogInProgressFinishOpen } = slice.actions

export default slice.reducer